import { Box } from "@mui/material"
import { HomeHeader } from "../../components/headers/HomeHeader"
import { Footer } from "../../components/footers/Footer"
import { ContactUsPopup } from "../../components/modals/ContactUsPopup"
import { useState } from "react"
import { Navigate, Route, Routes } from "react-router-dom"
import { LargeLossAlertsDetail } from "./details/LargeLossAlertsDetail"
import { EarlySeveritySignalDetectionDetail } from "./details/EarlySeveritySignalDetectionDetail"
import { ReserveAdequacyMonitoringDetail } from "./details/ReserveAdequacyMonitoringDetail"
import { HighSeverityPotentialClaimsDetail } from "./details/HighSeverityPotentialClaimsDetail"
import { ProactiveSeverityLitigationIntelligenceDetail } from "./details/ProactiveSeverityLitigationIntelligenceDetail"
import { IntelligentClaimsDocumentSummarizationDetail } from "./details/IntelligentClaimsDocumentSummarizationDetail"

export const Usecase = () => {
  const [isOpenContact, setIsOpenContact] = useState(false)

  const handleOpenContact = () => setIsOpenContact(true)
  const handleCloseContact = () => setIsOpenContact(false)

  return (
    <div className="w-full overflow-hidden bg-[#F9F9F9]">
      <HomeHeader headerColor={"#F9F9F9"} textColor={"#021744"} />
      <div className="usecase-page">
        <Box className="w-full py-20">
          <Routes>
            <Route index element={<Navigate to="/blogs/usecases" replace />} />
            <Route path="large-loss-alerts" element={<LargeLossAlertsDetail />} />
            <Route path="early-severity-signal-detection" element={<EarlySeveritySignalDetectionDetail />} />
            <Route path="reserve-adequacy-monitoring" element={<ReserveAdequacyMonitoringDetail />} />
            <Route path="high-severity-potential-claims" element={<HighSeverityPotentialClaimsDetail />} />
            <Route path="proactive-severity-litigation-intelligence" element={<ProactiveSeverityLitigationIntelligenceDetail />} />
            <Route path="intelligent-claims-document-summarization" element={<IntelligentClaimsDocumentSummarizationDetail />} />
            <Route path="*" element={<Navigate to="/blogs/usecases" replace />} />
          </Routes>

          <Box className="w-full text-center">
            <button
              onClick={handleOpenContact}
              className="text-[18px] leading-[24px] font-medium py-4 px-14 mt-10 border border-[#0D131E] hover:bg-[#0D131E] hover:text-white rounded-full transition-colors duration-300"
            >
              Contact Us
            </button>
            <ContactUsPopup open={isOpenContact} handleClose={handleCloseContact} />
          </Box>
        </Box>
      </div>
      <Footer />
    </div>
  )
}